module.exports = __webpack_public_path__ + "img/qian-two.f6c5451e.png";